module.exports = __webpack_public_path__ + "img/ordHialuronic1.fc9a5409.jpg";